export default function PHP_convert_uudecode() {
  return (
    <div>
      <h1>PHP_convert_uudecode</h1>
    </div>
  );
}
